<template>
    <div class v-if="tags_list.length>0">
        <div v-if="type=='div'">
            <div class="card mb-2" v-for="tag in tags_list"
                 :key="tag._id"
                 @click="updateValue(tag._id)">
                <div class="card-body p-2 pointer hover desk32-fz-md-14">
                    <button v-if="tag._id === current" @click.stop="clear" class="btn btn-white btn-sm border-0">
                        <i class="fe fe-x"></i>
                    </button>
                    <span>{{ tag.label}}</span>
                </div>
            </div>
        </div>
        <ul class="navbar-nav" v-else>
            <li class="nav-item" v-for="(tag, index) in tags_list" :key="index">
                <div class="nav-link pointer" :class="{'active':tag._id == current}">
                    <a href="#" @click.stop.prevent="updateValue(tag._id)">{{tag.label}}</a>
                    <button class="ml-3 btn btn-white btn-sm" @click="clear" v-if="tag._id === current">
                        <i class="fe fe-x"></i>
                    </button>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>

import { mapActions, mapState, mapGetters } from 'vuex';

export default {
    name: 'Tags',
    props: ['value', 'type'],
    data() {
        return {
            localValue: [],
            current: null,
        }
    },
    created() {
        // console.log('created');
        if (this.value)
            this.localValue = this.value;
    },
    watch: {
        localValue(newValue) {
            this.$emit('input', newValue);
        },
        value(newValue) {
            if (newValue === 'recent' || newValue === 'my') this.current = null;
            this.localValue = newValue;
        }
    },
    computed: {
        ...mapGetters('specialty', { findDataInStore: 'find', get: 'get' }),
        tags_list() {
            let result = this.findDataInStore().data;
            // result.unshift(
            //     { _id: 'mine', label: this.$t('Mine') },
            //     { _id: 'recent', label: this.$t('Recent') }
            // )
            return result;
        },


    },
    methods: {
        clear() {
            this.localValue = [];
            this.current = null;
        },

        updateValue(value) {
            this.current = value;
            this.localValue = value;
        },
    }

}
</script>
